module.exports = __webpack_public_path__ + "static/img/icon3-active.b59f6679.svg";